module.exports = __webpack_public_path__ + "img/doorLogo28.ab58544c.png";